'use client';
import { useTransition } from 'react';
import { Conditional } from '@cat-ecom/pcc-components';
import ErrorMessage from 'components/error-message';
import { revalidateServiceInsights } from 'services/commercial-offers/actions';
import { ServiceInsightHeading } from '../service-insight-card/service-insight-heading';
import { ServiceInsightSkeletonLoader } from '../service-insight-card/service-insight-loader';

export const ServiceInsightsErrorMessage = () => {
  const [ispending, startTransition] = useTransition();
  const handleOnRetry = () => {
    startTransition(async () => {
      await revalidateServiceInsights();
    });
  };

  return (
    <div className="pb-2 pb-lg-0 pt-4 pt-lg-0">
      <Conditional
        test={!ispending}
        fallback={<ServiceInsightSkeletonLoader />}
      >
        <ServiceInsightHeading isNewCount={false} />
        <ErrorMessage
          retryButtonLabel="RETRY"
          errorMessage="API_FAILURE_RETRY"
          onRetry={handleOnRetry}
        />
      </Conditional>
    </div>
  );
};
